import { Type, inject } from '@angular/core';
import { ApiQuery } from '@kinet-open-network/client/core/api-client';
import {
  patchState,
  signalStoreFeature,
  type,
  withMethods,
} from '@ngrx/signals';
import {
  CallState,
  setError,
  setLoaded,
  setLoading,
} from './call-state.feature';

/**
 * Adds export method to the store
 *
 * @param Service Service to inject (BaseApiService)
 * @param filename Filename to export to or function to generate filename, if not provided, the filename will be generated from the response headers
 */
export function withExport(
  Service: Type<{
    export: (query?: ApiQuery | null, filename?: string) => Promise<void>;
  }>,
  filename?: string | ((query?: ApiQuery | null) => string),
) {
  return signalStoreFeature(
    {
      state: type<{
        query: ApiQuery | null;
        callState: CallState;
      }>(),
    },
    withMethods((store, service = inject(Service)) => ({
      /**
       *
       * @param query Query to use when exporting, if not provided, the query from the store will be used
       */
      async export(query?: ApiQuery | null) {
        patchState(store, setLoading());

        try {
          await service.export(
            query ?? store.query(),
            typeof filename === 'function' ? filename(query) : filename,
          );
          patchState(store, setLoaded());
        } catch (error) {
          patchState(store, setError(error));
        }
      },
    })),
  );
}
